import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Simple service to receive and update loading signal
 * @class LoadingService
 * @typedef {LoadingService}
 */
@Injectable( {
    providedIn: 'root'
} )
export class LoadingService {
    /** signal current state to {@link LoadingComponent} */
    loading = new BehaviorSubject( false );

    /**
     * public interface to trigger loading
     * @param state {boolean} the state of loading, default is false
     */
    setLoading( state = false ) {
        this.loading.next( state );
    }
}
